// extracted by mini-css-extract-plugin
export default {"container":"TaskItem_container__WG1V6","tags":"TaskItem_tags__zPvWo","dateTime":"TaskItem_dateTime__3FP3E","delete":"TaskItem_delete__9YInb"};